<template>
  <div>
    <nd-dialog v-model="redPacketPopup" class="relending-dialog" :footer="false">
      <div class="relending-dialog-content" slot="custom">
        <div class="red-packet__top" ref="redPacket">
          <div class="redpacket-item">
            <div class="redpacket-content">
              <p class="p1">恭喜您！</p>
              <p class="p2">获得了{{day}}天免息</p>
            </div>
          </div>
        </div>
        <img class="red-packet__bottom" src="../images/icon_quanbao@2x.png" />
        <p class="red-packet__bottom-text">我的券包</p>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import 'web-animations-js/web-animations.min.js'

export default {
  data () {
    return {
      redPacketPopup: false
    }
  },
  props: {
    day: Number
  },
  methods: {
    open () {
      this.redPacketPopup = true
      this.$refs.redPacket.addEventListener('animationend', () => {
        this.redPacketPopup = false
        this.$emit('animationEnd')
      })
    }
  }
    
}
</script>
<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

@keyframes haloRotate {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes receive {
    from {
        transform: translate3d(0, 0, 0) scale(1);
    }
    to {
        transform: translate3d(0, 637px, 0) scale(0.1);
        opacity: 0;
    }
}
.relending-dialog-content{
    .red-packet__top{
        position: relative;
        &::before{
            content: "";
            position: absolute;
            left: -150px;
            top: 0;
            width: 750px;
            height: 750px;
            background: url(../images/img_2.png) center no-repeat;
            background-size: 100%;
            z-index: -1;
            animation: haloRotate 1s linear infinite;
        }
        .redpacket-item{
            width: 450px;
            height: 610px;
            background: url(../images/img_dizuo@2x.png) center no-repeat;
            background-size: 100%;
            padding-top: 39px;
            .redpacket-content{
                width: 317px;
                height: 451px;
                background: url(../images/img_card@2x.png) center no-repeat;
                background-size: 100%;
                margin: 0 auto;
                text-align: center;
                padding-top: 154px;
                .p1{
                    font-size: 40px;
                }
                .p2{
                    font-size: 32px;
                    motion-path: 3px;
                }
            }
        }
    }
    .red-packet__bottom{
        width: 100px;
        height: 100px;
        &-text{
            text-align: center;
            margin-top: 10px;
        }
    }
}
.turntable-popup-content {
    position: relative;
    width: 722px;
    height: 759px;
    margin: auto;
    .end {
        position: absolute;
        top: 0;
        left: 50%;
        width: 654px;
        height: 654px;
        transform: translate3d(-50%, 0, 0) rotate(0deg);
    }
    .front {
        position: absolute;
        top: 0;
        bottom: 0;
    }
}
.red-packet {
    &__top {
        position: relative;
        transform-origin: center center;
        animation: receive 2s forwards 2s;
        .light {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate3d(-50%, 0, 0);
            animation: rotate 1s linear infinite;
            width: 602px;
            height: 490px;
            z-index: 1;
        }
        .packet {
            position: relative;
            width: 459px;
            height: 599px;
            margin: auto;
            z-index: 2;
        }
        .result {
            position: absolute;
            width: 100%;
            top: 400px;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            z-index: 3;
            font-size: 30px;
            line-height: 50px;
            color: #fff;

            .DIN {
                font-size: 70px;
                font-family: DIN-Medium;
                font-weight: 500;
                color: rgba(255, 219, 75, 1);
            }
        }
        .close {
            position: absolute;
            top: 0;
            right: 0;
            width: 60px;
            height: 60px;
            z-index: 4;
        }
    }

    &__bottom {
        position: relative;
        margin: 287px auto 0;
        width: 146px;
        height: 152px;
    }
}
</style>
